"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _classnames = _interopRequireDefault(require("classnames"));

var _ = require("../.");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const FormRow = ({
  children,
  mobile,
  classes,
  className,
  noBottomGutter
}) => _react.default.createElement("div", {
  className: (0, _classnames.default)({
    [classes.formRow]: !mobile,
    [classes.formRowMobile]: mobile,
    [classes.noBottomGutter]: noBottomGutter,
    [className]: className
  })
}, children);

FormRow.propTypes = {
  mobile: _propTypes.default.bool
};

var _default = (0, _reactJss.default)(theme => {
  const commonStyling = {
    display: 'flex',
    alignItems: 'flex-end',
    marginBottom: theme.sizes.inputGutterBottom,
    '& .form-control': {
      marginBottom: 0
    },
    '& > div + *': {
      marginLeft: theme.sizes.formRowGutter
    }
  };
  return {
    formRow: {
      [(0, _.breakpoint)(theme.breakpoints.sm)]: commonStyling
    },
    formRowMobile: commonStyling,
    noBottomGutter: {
      marginBottom: 0
    }
  };
})(FormRow);

exports.default = _default;